import React from 'react';
import { useTranslation } from 'react-i18next';
import BaggageIcon from '../Icons/BaggageIcon';

interface Props {
  toggle(): void;
  cpfAlreadyExists: boolean;
}

const IncludeOnePersonErrorModal: React.FC<Props> = ({ toggle, cpfAlreadyExists }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper">
      <div className="icon-wrapper">
        <BaggageIcon />
      </div>
      <span className="title-success">{cpfAlreadyExists ? t('cpf_exists') : t('cant_include')}</span>
      <span className="subtitle">{cpfAlreadyExists ? t('cpf_exists_text') : t('verify_info')}</span>
      <button type="button" className="ok-button" onClick={toggle}>
        {cpfAlreadyExists ? 'Finalizar' : t('includeTeam:try_again')}
      </button>
    </div>
  );
};

export default IncludeOnePersonErrorModal;
